<template>
  <Meta
    name="twitter:title"
    :content="categoryData?.meta_title"
    v-if="categoryData?.meta_title"
  />
  <Meta
    name="og:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=13`"
  />
  <Meta
    name="twitter:image"
    :content="`https://boostingmarket.com/images/og-images/${currentGameSlug}-og.png?v=13`"
  />
  <Meta
    name="twitter:title"
    :content="categoryData?.meta_title"
    v-if="categoryData?.meta_title"
  />
  <Meta
    name="twitter:description"
    :content="categoryData?.description"
    v-if="categoryData?.description"
  />
  <Meta
    name="og:description"
    :content="categoryData?.description"
    v-if="categoryData?.description"
  />
  <Meta
    name="og:title"
    :content="categoryData?.meta_title"
    v-if="categoryData?.meta_title"
  />

  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/wow-pve-boost.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-if="currentGamePackSlug === 'wow-pve-boost'"
  />
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/wow-pvp-boost.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'wow-pvp-boost'"
  />
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/wow-collections.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-else-if="currentGamePackSlug === 'wow-collections.webp'"
  />

  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />
    <template v-if="categoryPackSlug !== 'wow-raid-boost'">
      <div
        class="d-flex-row align-start space-between xl-row-to-col gap-60 mobile-min-height"
      >
        <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
          <div class="d-flex-column justify-start align-start gap-16">
            <LazyCustomSeasonLengthNew
              v-if="showSeasonLength"
              :season-length="getGame?.game_season"
            />
            <CategoriesSelector />
          </div>
        </div>

        <div
          class="d-flex-column flex-65 justify-start align-start t-white gap-36"
        >
          <!-- PACKS HERE -->
          <SoloShuffle v-if="categoryPackSlug === 'wow-solo-shuffle-boost'" />
          <Arena2v2 v-else-if="categoryPackSlug === 'wow-2v2-arena-boost'" />
          <Arena3v3 v-else-if="categoryPackSlug === 'wow-3v3-arena-boost'" />
          <BattleGrounds
            v-else-if="categoryPackSlug === 'wow-battlegrounds-boost'"
          />
          <HonorFarm v-else-if="categoryPackSlug === 'wow-honor-boost'" />
          <ConquestPicker
            v-else-if="categoryPackSlug === 'wow-conquest-boost'"
          />
          <MythicPlus
            v-else-if="categoryPackSlug === 'wow-mythic-dungeon-boost'"
          />
          <LevelBoost v-else-if="categoryPackSlug === 'wow-leveling-boost'" />
          <BattleGroundBlitz
            v-else-if="categoryPackSlug === 'wow-battleground-blitz-boost'"
          />
          <div class="d-flex-column justify-start xl-hide">
            <div class="d-flex-column justify-start align-start gap-5">
              <label class="t-white font-family-1 title-h5 f-w-600">{{
                $t("new.info")
              }}</label>
              <p class="t-grey regular-l font-family-2">
                {{ $t(`new.info_desc_${categoryPackSlug}`) }}
              </p>
            </div>
            <Info
              :title="$t('membership.membership_8_title')"
              v-if="getGamePack?.loot_table?.length > 0"
              :infos="getGamePack?.loot_table"
            />
            <Info
              :title="$t('legend_exclusive_rewards.title')"
              v-if="categoryPackSlug === 'wow-solo-shuffle-boost'"
              :infos="[
                $t('legend_exclusive_rewards.first'),
                $t('legend_exclusive_rewards.second'),
                $t('legend_exclusive_rewards.third'),
              ]"
            />
            <Info
              :title="$t('gladiator_exclusive_rewards.title')"
              v-if="categoryPackSlug === 'wow-3v3-arena-boost'"
              :infos="[
                $t('gladiator_exclusive_rewards.first'),
                $t('gladiator_exclusive_rewards.second'),
                $t('gladiator_exclusive_rewards.third'),
                $t('gladiator_exclusive_rewards.fourth'),
                $t('gladiator_exclusive_rewards.fifth'),
                $t('gladiator_exclusive_rewards.sixth'),
                $t('gladiator_exclusive_rewards.seventh'),
                $t('gladiator_exclusive_rewards.eighth'),
              ]"
            />
            <Info
              :title="$t('raid-boost.completion_methods.title')"
              v-if="completion_methods.length > 0"
              :infos="completion_methods"
              type="method"
            />
            <Info
              :title="$t('new.requirements')"
              v-if="getGamePack?.requirements?.length > 0"
              :infos="getGamePack?.requirements"
            />

            <Info
              :title="$t('homepage.faq')"
              v-if="getGamePack?.faqs?.length > 0"
              :infos="getGamePack?.faqs"
              type="faq"
            />
          </div>
        </div>
        <div
          class="d-flex-column flex-2 justify-start align-start t-white cart_container"
        >
          <WhyWeCheap />
          <Cart />
          <SafeSecurePayments />
          <div
            class="d-flex-column justify-start above-xl-hide"
            style="margin-top: 24px"
          >
            <Info
              :title="$t('membership.membership_8_title')"
              v-if="getGamePack?.loot_table?.length > 0"
              :infos="getGamePack?.loot_table"
            />
            <Info
              :title="$t('raid-boost.completion_methods.title')"
              v-if="completion_methods.length > 0"
              :infos="completion_methods"
              type="method"
            />
            <Info
              :title="$t('new.requirements')"
              v-if="getGamePack?.requirements?.length > 0"
              :infos="getGamePack?.requirements"
            />

            <Info
              :title="$t('homepage.faq')"
              v-if="getGamePack?.faqs?.length > 0"
              :infos="getGamePack?.faqs"
              type="faq"
            />
          </div>
        </div>
      </div>
    </template>
    <!-- 
    <template v-if="($isMobile() || $isTablet()) && showPack">
      <MmoPackDetail />
      <template v-for="key in keys">
        <div
          class="pack_text_detail"
          v-html="getGamePack?.pack_description_detail[key]"
        ></div>
      </template>
      <MythicItems v-if="categoryPackSlug === 'wow-mythic-dungeon-boost'" />
    </template> -->
  </div>

  <template v-if="categoryPackSlug === 'wow-raid-boost'">
    <LazyPageCategoryPageRaidBoostPage />
  </template>
</template>

<script setup>
import GamePackBanner from "~/components/banners/GamePackBanner.vue";
import CategoriesSelector from "~/components/sections/boosting/CategoriesSelector.vue";
import Cart from "~/components/calculators/checkout/Cart.vue";
import SafeSecurePayments from "~/components/calculators/checkout/SafeSecurePayments.vue";
import Info from "~/components/custom/Info.vue";
import SoloShuffle from "~/components/calculators/wow/SoloShuffle.vue";
import Arena2v2 from "~/components/calculators/wow/Arena2v2.vue";
import Arena3v3 from "~/components/calculators/wow/Arena3v3.vue";
import BattleGrounds from "~/components/calculators/wow/BattleGrounds.vue";
import HonorFarm from "~/components/calculators/wow/HonorFarm.vue";
import ConquestPicker from "~/components/calculators/wow/ConquestPicker.vue";
import MythicPlus from "~/components/calculators/wow/MythicPlus.vue";
import LevelBoost from "~/components/calculators/wow/LevelBoost.vue";

import WhyWeCheap from "~/components/custom/WhyWeCheap.vue";
import BattleGroundBlitz from "~/components/calculators/wow/BattleGroundBlitz.vue";
import MmoPackDetail from "~/components/calculators/wow/pickers/MmoPackDetail.vue";

import MythicItems from "~/components/calculators/wow/raid/MythicItems.vue";
// HOOKS
const { categoryPackSlug, currentGameSlug, currentGamePackSlug } =
  useGameComposable();
const { getLocale } = useFunctions();
const { setGamePack, getGamePack, apiGetGame, getGame, apiGetGameRanks } =
  useGameStore();
const categoryData = ref(null);
const router = useRouter();
const { t } = useI18n();
const route = router.currentRoute;
const localePath = useLocalePath();
const completion_methods = computed(() => {
  if (categoryPackSlug === "wow-mythic-dungeon-boost") {
    return [
      t("wow-mythic-dungeon-boost.completion_methods.piloted"),
      t("wow-mythic-dungeon-boost.completion_methods.self_play"),
      t("wow-mythic-dungeon-boost.completion_methods.remote_control"),
    ];
  }
  if (categoryPackSlug === "wow-leveling-boost") {
    return [
      t("wow-leveling-boost.completion_methods.piloted"),
      t("wow-leveling-boost.completion_methods.self_play"),
      t("wow-leveling-boost.completion_methods.remote_control"),
    ];
  }

  if (
    categoryPackSlug === "wow-2v2-arena-boost" ||
    categoryPackSlug === "wow-solo-shuffle-boost" ||
    categoryPackSlug === "wow-3v3-arena-boost" ||
    categoryPackSlug === "wow-honor-boost" ||
    categoryData === "wow-conquest-boost" ||
    categoryPackSlug === "wow-battleground-blitz-boost"
  ) {
    return [
      t("wow-2v2-arena-boost.completion_methods.piloted"),
      t("wow-2v2-arena-boost.completion_methods.self_play"),
      t("wow-2v2-arena-boost.completion_methods.remote_control"),
    ];
  }

  return [];
});

const showPack = computed(() => {
  if (
    [
      // "wow-mythic-dungeon-boost",
      "wow-2v2-arena-boost",
      "wow-3v3-arena-boost",
      "wow-battlegrounds-boost",
      "wow-honor-boost",
      "wow-conquest-boost",
      "wow-battleground-blitz-boost",
    ].includes(categoryPackSlug)
  )
    return true;
  return false;
});

const { data: response, error } = await useApiFetch(
  `/api/get-mmo-game-pack/${categoryPackSlug}`,

  {
    fetchKey: `/api/get-mmo-game-pack/${categoryPackSlug}`,
    method: "POST",
    body: {
      locale: getLocale(),
      params: ["prices", "pack_options", "pack_extra_options", "faqs"],
    },
  }
);

if (error.value?.data && currentGameSlug !== "world-of-warcraft-boost") {
  throw createError({
    statusCode: "404",
    statusMessage: "Not Found",
  });
}
apiGetGame({
  gameSlug: currentGameSlug,
  locale: getLocale(),
});
apiGetGameRanks({
  gameSlug: currentGameSlug,
  locale: getLocale(),
});
if (response.value?.data) {
  setGamePack(response.value?.data);
  categoryData.value = response.value?.data;
  useSeoMeta({
    title: response.value?.data?.meta_title,
    description: response.value?.data?.description,
  });
}
addCanonicalLink(route.value.fullPath);

const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});
onNuxtReady(() => {});
</script>
